import React, {useContext} from 'react';
import {useHistory} from 'react-router-dom';
import {getCurrentPageRoutePart} from "../../utilities/Utility";
import {AppContext} from "../../context/app/appContext";

export const PerksProgramManagementMenu = (props) => {
    const history = useHistory();
    // const [subMenuActiveItem, setSubMenuActiveItem] = useState('Active');

    const appContext = useContext(AppContext);

    const handleSubMenuItemClick = (e) => {
        e.preventDefault();
        const name = e.target.innerText;
        // setSubMenuActiveItem(name);
        let routeLink = name.trim().toLowerCase();
        console.info({routeLink});
        history.push(`/programs/perk-programs/${routeLink}`);
    };

    return (
        <div className="" style={{ width: '90vw', backgroundColor: '#555555', marginBottom: 15, borderRadius: 2,}}>
            <nav className="ui inverted pointing secondary menu" style={{width: '100%', paddingLeft: 10}}>
                {/*<a href="#top" onClick={handleSubMenuItemClick} className={`item ${subMenuActiveItem === 'Active' ? 'active' : ''}`}>Active</a>
                <a href="#top" onClick={handleSubMenuItemClick} className={`item ${subMenuActiveItem === 'Expired' ? 'active' : ''}`}>Expired</a>*/}
                <a href="#top" onClick={handleSubMenuItemClick} className={`item ${getCurrentPageRoutePart() === 'active' ? 'active' : ''}`}>Active</a>
                <a href="#top" onClick={handleSubMenuItemClick} className={`item ${getCurrentPageRoutePart() === 'expired' ? 'active' : ''}`}>Expired</a>
                {/* <div className="right item">{appContext.organization.legalEntityName}</div> */}
            </nav>
        </div>
    );
};
